import { render, staticRenderFns } from "./FieldListItem.vue?vue&type=template&id=48822f96&scoped=true"
import script from "./FieldListItem.vue?vue&type=script&lang=js"
export * from "./FieldListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48822f96",
  null
  
)

export default component.exports